export declare namespace InspectionRepresentativeModalTokenSections {
	interface Select {
		borderColor: string;
	}

	interface Option {
		roleColor: string;
	}

	interface Detail {
		label: {
			color: string;
			fontSize: string;
			lineHeight: string;
			fontWeight: string;
		};
		value: {
			color: string;
			fontSize: string;
			lineHeight: string;
			fontWeight: string;
		};
		gap: string;
	}

	interface DefaultBadge {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
		minWidth: string;
	}
}

export type InspectionRepresentativeModalTokens = {
	select: InspectionRepresentativeModalTokenSections.Select;
	option: InspectionRepresentativeModalTokenSections.Option;
	detail: InspectionRepresentativeModalTokenSections.Detail;
	defaultBadge: InspectionRepresentativeModalTokenSections.DefaultBadge;
};

export const select: InspectionRepresentativeModalTokenSections.Select = {
	borderColor: '{form.field.focus.border.color}',
};

export const option: InspectionRepresentativeModalTokenSections.Option = {
	roleColor: '{text.muted.color}',
};

export const detail: InspectionRepresentativeModalTokenSections.Detail = {
	label: {
		color: '{text.color}',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: '600',
	},
	value: {
		color: '{text.color}',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: '400',
	},
	gap: '6px',
};

export const defaultBadge: InspectionRepresentativeModalTokenSections.DefaultBadge = {
	color: '{successText.color}',
	fontSize: '12px',
	fontWeight: '300',
	lineHeight: '20px',
	minWidth: '65px',
};

export default {
	select,
	option,
	detail,
	defaultBadge,
} satisfies InspectionRepresentativeModalTokens;
